import { render, staticRenderFns } from "./AppEmptyResult.vue?vue&type=template&id=a1b1d902&scoped=true&"
import script from "./AppEmptyResult.vue?vue&type=script&lang=js&"
export * from "./AppEmptyResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1b1d902",
  null
  
)

export default component.exports